import { useSelector } from 'react-redux'
import { IRootState } from '../../../redux/types'

export function ValidateMenu(menuId: number) {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  return authUser !== null && (authUser.role_id === 1 || authUser.menus.find((menu: any) => menu.id === menuId) !== undefined)
}

function HasKnowToBuy(props: any) {
  if (ValidateMenu(6)) {
    return props.children
  }

  return <></>
}

export default HasKnowToBuy
